const slotTheme = (theme) => ({
  choosenSlot: {
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: '#e5e5e5'
  },
  blockedSlot: {
    //border: `1px solid ${theme.palette.secondary.main}`,
  },
  adminOnlySlot: {
    //border: `1px dashed ${theme.palette.secondary.main}`,
  },
  reservedSlot: {
    border: `1px dashed ${theme.palette.grey[500]}`,
  },
  partiallyBookedSlot: {
    border: `1px dashed ${theme.palette.primary.main}`,
  },
  bookedSlot: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
})

export default slotTheme
